import { DatePipe, NgIf } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { StateService } from '../../../services/state.service'

@Component({
  selector: 'app-device-register-widget',
  standalone: true,
  imports: [DatePipe, NgIf],
  templateUrl: './device-register.component.html',
  styleUrls: ['./device-register.component.scss'],
})
export class DeviceRegisterComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription()

  isRegistered?: boolean
  code?: string
  expireAt?: Date
  message?: string

  requestInterval: any
  requestTime = 0

  constructor(private stateService: StateService) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.stateService.isRegistered$.subscribe(isRegistered => {
        this.isRegistered = isRegistered
        if (this.isRegistered) {
          this.cancelRequestTimer()
          this.code = undefined
          this.expireAt = undefined
        } else {
          this.registerRequestTimer()
          this.code = this.stateService.code
          this.expireAt = this.stateService.expireAt
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe()
  }

  cancelRequestTimer(): void {
    if (this.requestInterval) {
      clearTimeout(this.requestInterval)
    }
    this.message = undefined
  }

  registerRequestTimer(): void {
    this.cancelRequestTimer()
    let count = 0
    this.requestInterval = setInterval(() => {
      count++
      this.requestTime = 5 - count
      if (count == 5) {
        this.stateService.checkRegistration()
        count = 0
      }
      this.message = 'Next verification in ' + this.requestTime
    }, 1000)
  }
}
